import React, {useEffect, useState} from 'react';
import Header from '../components/Header';
import {Link, RouteComponentProps} from 'react-router-dom';
import Footer from '../components/Footer';
import {useForm} from 'react-hook-form';
import useValidation from '../useHooks/useValidation';
import service from '../services/service';
import Input from '../components/Input';
import NewsLetterModal from '../components/NewsLetterModal';
import {ISSRData, Property} from "../interfaces";
import {useAxios} from "../useHooks/useAxios";
import {IResponse} from "../interfaces/response.interface";
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

interface IBlogTemplateProps extends RouteComponentProps<any> {
    ssrData: ISSRData;
}

const BlogTemplate = (props) => {
    const {match, ssrData} = props as IBlogTemplateProps;
    const {id} = match.params;
    const {article} = (ssrData || {}) as ISSRData;
    const isMatchedArticleWithIndex = article && article.documentId === id;
    const [item, setItem] = useState<any | undefined>(isMatchedArticleWithIndex ? article : undefined);
    const {data, request} = useAxios<IResponse<Property>>(service.getArticle);

    useEffect(() => {
        if ((!article || !isMatchedArticleWithIndex)) {
            request(id);
        }
    }, [article, request]);

    useEffect(() => {
        if (data) setItem(data.data);
    }, [data]);

    const {handleSubmit, register, errors, reset} = useForm({
        mode: 'onChange',
        reValidateMode: 'onChange'
    });
    const validation = useValidation();
    const [isOpen, setIsOpen] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const handleClose = () => {
        setIsOpen(false);
        setIsSuccess(false);
    }

    const onSubmit = (data: any) => {
        setIsLoading(true);
        service.subscribe(data.email)
            .then(res => {
                if (res.success) {
                    reset();
                    setIsSuccess(true);
                    setIsOpen(true);
                }
            })
            .finally(() => {
                setIsLoading(false);
            })
    };

    return (

        <div className="page-bg">
            <NewsLetterModal isOpen={isOpen} onClose={handleClose} defaultIsSuccess={isSuccess}/>
            <div className="page page-about">
                <Header/>
                <main className="blog-main">
                    <div className="container blog-big_top">
                        <p className="back-link"><Link to={'/blog'}><span>Retour au blog</span></Link></p>
                        <article className="blog-big">
                            <div className="blog-columns2 blog-big_first">
                                <div className="blog-columns2_left">
                                    <h1>{item?.title}</h1>
                                    <p>&nbsp;</p>
                                </div>
                                <div className="blog-columns2_right">
                                    <figure className="pic"><img src={item?.image?.url}/>
                                    </figure>
                                </div>
                            </div>
                            <div className="blog-columns2">
                                <div className="blog-columns2_left">
                                    <h3>{item?.topSection?.title}</h3>
                                    <div className="main"><ReactMarkdown rehypePlugins={[rehypeRaw as any]}>{item?.topSection?.content}</ReactMarkdown>
                                    </div>
                                </div>
                                <div className="blog-columns2_right">
                                    {item?.topSection?.image && <figure className="pic"><img
                                        src={item?.topSection?.image?.url}/></figure>}
                                </div>
                            </div>
                        </article>
                    </div>
                    <div className="container">
                        <article className="blog-big">
                            {item?.middleSection &&
                                <section className="blog-big_pic">
                                    {item.middleSection?.image && <figure className="pic-big"><img
                                        src={item?.middleSection?.image?.url}/></figure>}
                                    <div className="blog-columns_top">
                                        <h3>{item?.middleSection?.title}</h3>
                                    </div>
                                    <div className="blog-columns">
                                        <div className="blog-columns_left">
                                            <ReactMarkdown rehypePlugins={[rehypeRaw as any]}>{item?.middleSection?.content}</ReactMarkdown>
                                        </div>
                                    </div>
                                </section>
                            }
                            {item?.bottomSection && <div className="blog-columns" key={item.id}>
                                <div className="blog-columns_left">
                                    <p className="highlighted">{item.bottomSection.title}</p>
                                    <ReactMarkdown rehypePlugins={[rehypeRaw as any]}>{item.bottomSection.content}</ReactMarkdown>
                                </div>
                                {item.bottomSection.image && <div className="blog-columns2_right">
                                    <figure className="pic"><img src={item.bottomSection.image.url}/>
                                    </figure>
                                </div>}
                            </div>
                            }
                        </article>
                    </div>
                </main>
                <section className="section-subscribe">
                    <div className="container">
                        <article className="section-subscribe_left">
                            <p className="title">NEWSLETTER</p>
                            Recevez des conseils et informations sur l'actualité de l'immobilier avec notre newsletter.
                        </article>
                        <form onSubmit={handleSubmit(onSubmit)} className="section-subscribe_form">
                            <Input conClassName={'input'} errors={errors} name={'email'} label={'Email*'}
                                   ref={register(validation.email)}/>
                            <button disabled={isLoading} type="submit" className="btn btn-gradient">Je m’inscris
                            </button>
                        </form>
                    </div>
                </section>

                <section className="section-conseil">
                    <div className="container">
                        <Link to={'/conseil'}>
                            <figure className="section-conseil_pic"><img
                                src={require('../assets/images/expertise.svg')}/></figure>
                        </Link>
                    </div>
                </section>

                <Footer/>
            </div>
        </div>
    )
};

export default BlogTemplate;
